export class SystemMessage {
    publisherId: string;
    message: string;
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/models/system-message.ts